import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_VEHICLES_HISTORY_COLOR = {
  'colorsHistory': [],
  'activeProductions': [],
  'allvehiclesPrices': {'data': [], 'loading': false},
  'activeColorsList': [],
  'activeColorsEmpty': [],
  'loadingPrices': false,
  'loading': false,
  'loadingHistory': false,
  'loadingSave': false,
  'initialState': {
    'price': 0,
    'currency': 'USD',
    'startDate': null,
    'endDate': null,
  },
};

export const vehiclePriceColor = (state, action) => {
  return createReducer(INITIAL_STATE_VEHICLES_HISTORY_COLOR, {
    [ActionTypes.FETCHING_ALL_ACTIVE_PRICES]: (state, action) => ({
      ...state,
      'allvehiclesPrices': {'data': [], 'loading': true},
    }),
    [ActionTypes.FETCHED_ALL_ACTIVE_PRICES]: (state, action) => ({
      ...state,
      'allvehiclesPrices': {'data': action.response.data, 'loading': false},
    }),
    [ActionTypes.FETCHED_ALL_ACTIVE_PRICES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'allvehiclesPrices': {'data': [], 'loading': false},
    }),
    
    [ActionTypes.FETCHING_HISTORY_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingHistory': true,
    }),
    [ActionTypes.FETCHED_HISTORY_PRICE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loadingHistory': false,
      'colorsHistory': [],
    }),
    [ActionTypes.FETCHED_HISTORY_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingHistory': false,
      'colorsHistory': action.response.data,
    }),
    [ActionTypes.FETCHING_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingPrices': true,
    }),
    [ActionTypes.FETCHED_ACTIVE_PRICE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loadingPrices': false,
      'activeColorsList': [],
    }),
    [ActionTypes.FETCHED_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingPrices': false,
      'activeColorsList': [...action.response.data],
    }),

    [ActionTypes.FETCHING_EMPTY_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingPrices': true,
    }),
    [ActionTypes.FETCHED_EMPTY_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingPrices': false,
      'activeColorsEmpty': action.response.data,
    }),
    [ActionTypes.FETCHED_EMPTY_PRICE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loadingPrices': false,
      'activeColorsEmpty': [],
    }),

    [ActionTypes.FETCHING_ACTIVE_PRODUCTIONS]: (state, action) => ({
      ...state,
      'loading': true,
      'activeProductions': [],
    }),
    [ActionTypes.FETCHED_ACTIVE_PRODUCTIONS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'activeProductions': [],
    }),
    [ActionTypes.FETCHED_ACTIVE_PRODUCTIONS]: (state, action) => ({
      ...state,
      'loading': false,
      'activeProductions': action.response.data,
    }),
    [ActionTypes.CREATING_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingSave': true,
    }),
    [ActionTypes.CREATED_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingSave': false,
    }),
    [ActionTypes.CREATED_ACTIVE_PRICE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loadingSave': false,
    }),
    [ActionTypes.EDITING_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingSave': true,
    }),
    [ActionTypes.EDITED_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingSave': false,
    }),
    [ActionTypes.EDIT_ACTIVE_PRICE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loadingSave': false,
    }),
    [ActionTypes.CLEAR_COLORS_HISTORY]: (state, action) => ({
      ...state,
      'loadingHistory': false,
      'colorsHistory': [],
    }),
    [ActionTypes.CLEAR_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'activeColorsList': [],
      'activeColorsEmpty': [],
    }),
    [ActionTypes.UPDATING_ACTIVE_PRICE_COLORS]: (state, action) => ({
      ...state,
      'loadingSave': true,
    }),
    [ActionTypes.UPDATED_ACTIVE_PRICE_COLORS]: (state, action) => {
      return ({
        ...state,
        'loadingSave': false,
      });
    },
    [ActionTypes.UPDATED_ACTIVE_PRICE_COLORS_FAILED]: (state, action) => ({
      ...state,
      'loadingSave': false,
    }),
  })(state, action);
};
